import { useEffect, useState } from "react";

import { useNavigateToLink } from "../hooks/useNavigateToLink";
import { ROUTES } from "../routes";

import { Button } from "./ui/button";

// Mobile Sticky CTA Bar - Only visible on mobile after scrolling
export default function FinalCTAMobile() {
  const navigateToLink = useNavigateToLink();

  const [showMobileCTA, setShowMobileCTA] = useState(false);

  // Scroll tracking
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // Show mobile CTA after scrolling 300px down
      if (scrollTop > 300) {
        setShowMobileCTA(true);
      } else {
        setShowMobileCTA(false);
      }
    };

    handleScroll(); // Initial call
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    showMobileCTA && (
      // Explicitly dark-scoped so the bar looks the same on light and dark pages.
      <div className="dark bg-background/95 text-foreground animate-in slide-in-from-bottom fixed right-0 bottom-0 left-0 z-50 border-t p-4 shadow-lg backdrop-blur-md duration-300 lg:hidden">
        <div className="flex items-center justify-between gap-4">
          <div className="text-left">
            <p className="text-muted-foreground text-sm">
              Ready to ship faster?
            </p>
            <p
              className="text-foreground"
              style={{ fontSize: "var(--text-base)", fontWeight: "600" }}
            >
              Start free today
            </p>
          </div>
          <Button
            onClick={(e: React.MouseEvent) =>
              navigateToLink(e, ROUTES.register)
            }
            className="shrink-0"
            style={{ backgroundColor: "#0247FE" }}
          >
            Start Free
          </Button>
        </div>
      </div>
    )
  );
}
